import React from 'react';

import LogoThisIsMoney from '../../../images/partners/this-is-money.png';
import { sundaytimesIcon, itvIcon, independentIcon, guardianIcon, dmIcon } from '../../../images/images';
const AsFeaturedIn = () => {
    const featuredImages = [
        {
            src: itvIcon,
            alt: 'ITV',
            width: '40px',
        },
        {
            src: guardianIcon,
            alt: 'The Guardian',
            width: '100px',
        },
        {
            src: sundaytimesIcon,
            alt: 'Sunday Times',
            width: '100px',
        },
        {
            src: independentIcon,
            alt: 'Independent',
            width: '140px',
        },
        {
            src: LogoThisIsMoney,
            alt: 'This is Money',
            width: '100px',
        },
        {
            src: dmIcon,
            alt: 'Daily Mail',
            width: '80px',
        },
    ];

    const logos = [];
    for (let i = 0; i < featuredImages.length; i++) {
        const logo = featuredImages[i];
        const hiddenMobile = i > 2 ? 'partner__logo__column__container--hidden-mobile' : '';

        logos.push(
            <div
                className={`app__grid__column__six-one__mobile__three-one ${hiddenMobile}`}
                key={i}>
                <div className="partner__logo__column__container">
                    <div className="partner__logo__column">
                        <img src={logo.src} width={logo.width} alt={logo.alt} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="app__contact-page__section featured-in">
            <h5 className="vouchedfor-brand">As Featured In</h5>
            <div className="under-title"></div>
            <div className="app__contact-page__section-inside">{logos}</div>
        </div>
    );
};

export default AsFeaturedIn;
